<template>
  <div class="container">
      <CommonBreadcrumb class="bread_block" />
      <CommonTitleDescription :title="tags.seo.value.page_title" :description="tags.seo.value.page_description" :total="resultCount" />

      <InspirationFilters :filters="filters" @selectOption="toggleFilters" @searchOption="searchOption" @resetFilter="resetFilter" :searchTerm="payload.sku"/>
      <!-- @changeViewType="changeViewType" -->
          <div class="row">
          <!-- <div class="loader" v-if="pending">
            <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg" />
          </div> -->

        <InspirationPreview :data="data" v-for="data in listing" :key="data.id" 
        />
        <!--  @changeViewType="changeViewType"  :viewType="viewType"-->
        </div>

        <CommonNoResultFound class="mt-1 pt-1" v-if="listing.length === 0 && !pending" :type="'no_result'" />
        
        <div class="text-center mx-auto my-5 more_data_box" v-if="nextPage">
          <div class="loader" v-if="pending">
            <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg" />
          </div>
        <!-- <CommonButtonLight v-else @click="showMore()">SHOW MORE</CommonButtonLight> -->
        <div class="show_more_btn" v-else @click="showMore()">SHOW MORE</div>
      </div>

      <CommonH2TitleDescription :title="tags.seo.value.h2_title" :description="tags.seo.value.h2_description" /> 

      <FaqDynamicFaq class="mt-4 pt-4" />
    </div>
</template>


<script setup>
const route = useRoute()
const router = useRouter()
import { useSeo } from '@/composables/seo/setMetaTags'
const tags = useSeo();

const sku = computed(() => route.query.sku || route.query.search);

const slug = computed (()=>route.params.slug)


const props = defineProps({
  type: Array,
  value: String
});

const listing = ref([]);
const nextPage = ref(true)
const payload = ref({
  page: 1,
  sku: sku.value,
});

const caratValues = {
  '1': '1.00-1.99',
  '2': '2.00-2.99',
  '3': '3.00-3.99',
};

const filters = reactive({
  metal_color: [
    // { id: 31, icon: '', label: 'All Metals', value: '', active: true },
    { id: 32, icon: 'white', label: 'White Gold', value: 'white', active: false },
    { id: 33, icon: 'yellow', label: 'Yellow Gold', value: 'yellow', active: false },
    { id: 34, icon: 'rose', label: 'Rose Gold', value: 'rose', active: false },
    { id: 35, icon: 'white', label: 'Platinum', value: 'platinum', active: false }
  ],
  style: [
    // { id: 1, icon: '', label: 'All Styles', value: '', active: true },
    { id: 2, icon: 'solitaire', label: 'Solitaire', value: 'solitaire', active: false },
    { id: 3, icon: 'halo', label: 'Halo', value: 'halo', active: false },
    { id: 4, icon: 'three_stone', label: 'Three Stone', value: 'three-stone', active: false },
    { id: 5, icon: 'side_stone', label: 'Side Stone', value: 'side-stone', active: false },
    { id: 6, icon: 'vintage', label: 'Vintage', value: 'vintage', active: false }
  ],
  shape: [
    // { id: 11, icon: '', label: 'All Shapes', value: '', active: true },
    { id: 12, icon: 'round', label: 'Round', value: 'round', active: false },
    { id: 13, icon: 'oval', label: 'Oval', value: 'oval', active: false },
    { id: 14, icon: 'pear', label: 'Pear', value: 'pear', active: false },
    { id: 15, icon: 'cushion', label: 'Cushion', value: 'cushion', active: false },
    { id: 16, icon: 'princess', label: 'Princess', value: 'princess', active: false },
    { id: 17, icon: 'emerald', label: 'Emerald', value: 'emerald', active: false },
    { id: 18, icon: 'heart', label: 'Heart', value: 'heart', active: false },
    { id: 19, icon: 'radiant', label: 'Radiant', value: 'radiant', active: false },
    { id: 20, icon: 'marquise', label: 'Marquise', value: 'marquise', active: false }
  ],
  carat: [
    // { id: 21, icon: '', label: 'All Carats', value: '', active: true },
    { id: 22, icon: '', label: '0.30 - 0.49 CT', value: '0.30-0.49', active: false },
    { id: 23, icon: '', label: '0.50 - 0.99 CT', value: '0.50-0.99', active: false },
    { id: 24, icon: '', label: '1.00 - 1.99 CT', value: '1.00-1.99', active: false },
    { id: 25, icon: '', label: '2.00 - 2.99 CT', value: '2.00-2.99', active: false },
    { id: 26, icon: '', label: '3.00 - 3.99 CT', value: '3.00-3.99', active: false },
    { id: 27, icon: '', label: '4.00 + CT', value: '4.00-10.00', active: false }
  ],
  sort_by: [
    { id: 51, icon: '', label: 'Default', value: '', active: true },
    { id: 52, icon: '', label: 'Carat - Low to High', value: 'carat-asc', active: false },
    { id: 53, icon: '', label: 'Carat - High to Low', value: 'carat-desc', active: false },
    { id: 54, icon: '', label: 'Price - Low to High', value: 'price-asc', active: false },
    { id: 55, icon: '', label: 'Price - High to Low', value: 'price-desc', active: false }
  ]
})

const activeUrl = () => {
  Object.keys(filters).forEach((key) => {
    filters[key].forEach((item) => {
      if (route.query[key] == item.value) {
        item.active = true;
        payload.value = route.query
        payload.value.page = 1
      }
    })
  })

}
activeUrl()


const resetFilter = () => {
  Object.keys(filters).forEach((key) => {
    filters[key].forEach((item) => {
      item.active = false;
      if (item.value === '') {
        item.active = true;
      }
    });
  });
  toggleFilters();
};

const updateUrl = () => {
  let query = { ...payload.value };
  delete query.page;
  delete query.sku;
  router.push({ query })
};

const setPayload = () => {
    Object.keys(filters).forEach((key) => {
      filters[key].forEach((item) => {
        if (item.value === '') {
          delete payload.value[key];
        }
        if (item.active && item.value !== '') {        
          payload.value[key] = item.value;
        }
      });
  });

    updateUrl();
};

const searchBox = () => {
  if (!route?.query?.search && !route?.query?.sku) {
    return;
  } else {

    if (route?.query?.sku) {
      // payload.value.sku = route.query.sku;
      payload.value.search = route.query.sku; 
    }
    if (route?.query?.search) {
      payload.value.search = route.query.search;
    }
  }
  setPayload();
}
searchBox()
const checkUrl = () => {
  Object.keys(filters).forEach((key) => {

    if (key === route.meta.type) {

    }
    filters[key].forEach((item) => {
    
if (route.meta.value === item.value) {
        item.active = true;
      }
    })
  },
  )
  setPayload()
}
checkUrl()

const toggleFilters = () => {
  payload.value.page = 1
  listing.value = []
  setPayload();
  updateUrl();
  refresh();
}
const activateShapeFilters = () => {
  const shapeSlug = slug?.value;
  const shapeToActivate = filters.shape?.find(shape => shape.value === shapeSlug);
  if (shapeToActivate) {
    shapeToActivate.active = true;
    setPayload(); 
  }
};

const activateCaratFilters = () => {
  const caratSlug = slug?.value; 
  if (caratValues?.[caratSlug]) {
    filters.carat?.find(carat => {
      if (carat.value === caratValues[caratSlug]) {
        carat.active = true;
        setPayload();
      }
    });
  }
};
const initializeFilters = () => {
  activateCaratFilters();
  activeUrl(); 
  activateShapeFilters()
};

initializeFilters(); 

const searchOption = (value) => {
  payload.value.page = 1
  if (value == '') {
    delete payload.value.search;
    delete payload.value.sku; 
  }
  if (value !== '') {
    payload.value.search = value
  }
  updateUrl()
  listing.value = []
  setPayload()
  refresh()
}

const { data, error, refresh, pending } = await useLazyFetch(useCountryPath('/config/recently-purchases/json?page=1'), {
  query: payload,
  watch: [payload],
  transform: (res) => {
    if (res.item.length > 0) {
      res.item.forEach((item) => {
        listing.value.push(item)
    });
    } 
    else {
      nextPage.value = false
    }
    nextPage.value = res.next_page_url
  }
});

const showMore = () => {
  payload.value.page++;
  refresh()
};

if(import.meta.client){

}
await tags.setMetaTags()
// function changeViewType(type) {
//   emit('changeViewType', type)
// }
</script>


<style scoped>
.more_data_box {
width: fit-content;
}

.title_block {
margin-top: 0 !important;
}

.loader {
display: flex;
align-items: center;
justify-content: center;
}

.show_more_btn {
border: 1px solid #000;
border-radius: 4px;
letter-spacing: 1.4px;
font-size: 14px;
font-weight: 600;
margin: 0 auto;
padding: 11px 25px;
text-transform: uppercase;
width: 100%;
cursor: pointer;
}
</style>